import type { Domain } from '@/entities/domain';
import request from '@/shared/api/request';

export const getDomain = (name: string): Promise<{ domain: Domain }> =>
  request({
    url: `/domains/${name}/`,
  });
